import axios from 'axios';
import { ENDPOINTS } from '../constants/endpoints';
import { FixedAssetSettings } from '../interfaces/fixedAsset/fixedAssetSettings.interface';

export const FixedAssetSettingsService = {
  getByInstitution: async (institutionId: string): Promise<FixedAssetSettings> =>
    (await axios.get(ENDPOINTS.FIXED_ASSET_SETTINGS.BY_INSTITUTION(institutionId))).data,
  upsert: async (dto: FixedAssetSettings): Promise<FixedAssetSettings> =>
    (await axios.put(ENDPOINTS.FIXED_ASSET_SETTINGS.UPSERT, dto)).data,
};
